export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_02.3695a2b3.jpg";